import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const SelectComponent = props => {
  const { value, onChange, variant } = props;

  return (
    <FormControl variant={variant}>
      <Select
        native
        value={value}
        onChange={onChange}
        inputProps={{
          condicion: value,
        }}
      >
        <option aria-label='None' value='' />
        <option value='='> Igual </option>
        <option value='<'>Menor que</option>
        <option value='>'>Mayor que</option>
        <option value='>='>Mayor o igual que</option>
        <option value='<='>Menor o igual que</option>
        <option value='LIKE'> Like </option>
      </Select>
    </FormControl>
  );
};

export default SelectComponent;
